import styles from "./OnboardingCostsModal.module.css";
import { useLocalization } from "../../contexts/LocalizationContext";

const OnboardingCostsModal = ({ visible, onClose, onOpenProduct, onOpenOperating }) => {
  const { t, locale } = useLocalization();
  const isRTL = locale === "ar";

  if (!visible) return null;

  return (
    <div className={styles.overlay} onClick={onClose} role="presentation">
      <div
        className={`${styles.modal} ${isRTL ? styles.rtl : ""}`}
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <h3 className={styles.title}>
          {t("OnboardingCostsModal.title") || "Action needed"}
        </h3>
        <p className={styles.body}>
          {t("OnboardingCostsModal.body") ||
            "Before we move to the next stage, add product costs and operating costs so Zeqi can finish your assessment."}
        </p>
        <div className={styles.actions}>
          <button className={styles.primary} onClick={onOpenProduct}>
            {t("OnboardingCostsModal.productCosts") || "Product Costs"}
          </button>
          <button className={styles.secondary} onClick={onOpenOperating}>
            {t("OnboardingCostsModal.operatingCosts") || "Operating Costs"}
          </button>
        </div>
        <button className={styles.dismiss} onClick={onClose}>
          {t("OnboardingCostsModal.dismiss") || "Dismiss"}
        </button>
      </div>
    </div>
  );
};

export default OnboardingCostsModal;
